/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as s from "react";
import e from "prop-types";
import { validatePackage as o, classNames as n } from "@progress/kendo-react-common";
import { packageMetadata as d } from "./package-metadata.mjs";
const i = (a) => {
  const t = {
    direction: "start",
    ...a
  };
  o(d);
  const r = n(
    {
      "k-form-hint": !0,
      "k-text-start": t.direction === "start",
      "k-text-end": t.direction === "end",
      "k-text-disabled": t.editorDisabled === !0
    },
    t.className
  );
  return /* @__PURE__ */ s.createElement(
    "div",
    {
      id: t.id,
      style: t.style,
      className: r
    },
    t.children
  );
};
i.propTypes = {
  id: e.string,
  direction: e.oneOf(["start", "end"]),
  children: e.oneOfType([
    e.element,
    e.node
  ]),
  style: e.object,
  className: e.string,
  editorDisabled: e.bool
};
i.displayName = "KendoReactHint";
export {
  i as Hint
};
